import type { TFunction } from 'i18next';

/** DB/API status strings (Arabic or English) → i18n key under pages.detail.status.* */
const STATUS_TO_KEY: Record<string, string> = {
  نشط: 'active',
  active: 'active',
  'قيد الانتظار': 'pending',
  pending: 'pending',
  مباع: 'sold',
  sold: 'sold',
  'تمت الصفقة': 'sold',
  'غير مباع': 'unsold',
  unsold: 'unsold',
  منتهي: 'ended',
  ended: 'ended',
  منتهٍ: 'ended',
  ملغي: 'cancelled',
  cancelled: 'cancelled',
  canceled: 'cancelled',
  محذوف: 'deleted',
  deleted: 'deleted'
};

export function translateAuctionStatus(status: string | undefined | null, t: TFunction): string {
  const s = String(status ?? '').trim();
  const key = STATUS_TO_KEY[s];
  if (key) return t(`pages.detail.status.${key}`);
  return s;
}

function statusKind(status: string | undefined | null): string | undefined {
  return STATUS_TO_KEY[String(status ?? '').trim()];
}

/** True when listing can be edited (API may return Arabic or English status). */
export function isAuctionActiveStatus(status: string | undefined | null): boolean {
  return statusKind(status) === 'active';
}

export function isAuctionSoldStatus(status: string | undefined | null): boolean {
  return statusKind(status) === 'sold';
}

export function isAuctionUnsoldStatus(status: string | undefined | null): boolean {
  return statusKind(status) === 'unsold';
}

/** Active or pending approval — e.g. bidding UI eligibility. */
export function isAuctionActiveOrPendingStatus(status: string | undefined | null): boolean {
  const k = statusKind(status);
  return k === 'active' || k === 'pending';
}

/** Ended with outcome (sold or unsold). */
export function isAuctionSoldOrUnsoldStatus(status: string | undefined | null): boolean {
  const k = statusKind(status);
  return k === 'sold' || k === 'unsold';
}

export function isAuctionEndedStatus(status: string | undefined | null): boolean {
  return statusKind(status) === 'ended';
}

export function isAuctionCancelledStatus(status: string | undefined | null): boolean {
  return statusKind(status) === 'cancelled';
}
